import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPlayer from 'react-player';
import {
  faHeadphones,
  faMicrophoneLines,
  faMusic,
  faCompactDisc,
  faFileSignature,
  faMicrophone,
  faBuilding,
  faPerson,
  faFile,
  faFileAudio,
  faSearch,
  faCalendar,
  faLanguage,
  faPeopleCarry,
  faLayerGroup,
  faPenNib,
  faFingerprint,
} from '@fortawesome/free-solid-svg-icons';

import { faFileLines, faImage } from '@fortawesome/free-regular-svg-icons';

import { message } from 'antd';
import { Progress } from 'react-sweet-progress';
import 'react-sweet-progress/lib/style.css';
import Loader from '../../Loader';
import $ from 'jquery';
import { ApiConsumer } from 'api/ApiConsumer';
import { API_ROUTES } from 'routes/api';
import { useHistory } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/solid';
import {
  faDeezer,
  faSpotify,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { useAuthentication } from 'hooks/AuthenticationHook';
import { NotificationContext } from 'context/NotificationContext';

const _validFileExtensions = ['.mp3', '.wav', '.mp4', '.mp4v'];
const _validFileExtensionsArtwork = ['.jpg', '.jpeg', '.png', '.gif'];

const genres = [
  { id: 1, value: 'amapiano', name: 'Amapiano' },
  { id: 2, value: 'gospel', name: 'Gospel' },
  { id: 3, value: 'house', name: 'House' },
  { id: 4, value: 'hip-hop', name: 'Hip Hop' },
  { id: 5, value: 'kwaito', name: 'Kwaito' },
  { id: 6, value: 'pop', name: 'Pop' },
  { id: 7, value: 'jazz', name: 'Jazz' },
  { id: 8, value: 'r&b', name: 'R&B' },
  { id: 9, value: 'reggae', name: 'Reggae' },
  { id: 10, value: 'rock', name: 'Rock' },
  { id: 11, value: 'classical', name: 'Classical' },
  { id: 12, value: 'traditional', name: 'Traditional' },
  { id: 13, value: 'afro-pop', name: 'Afro Pop' },
  { id: 14, value: 'other', name: 'Other' },
];


  const countries = [
  { id: 23, value: 'bw', name: 'Botswana' }, // <-- Botswana
  { id: 1,  value: 'af', name: 'Afghanistan' },
  { id: 2,  value: 'al', name: 'Albania' },
  { id: 3,  value: 'dz', name: 'Algeria' },
  { id: 4,  value: 'ad', name: 'Andorra' },
  { id: 5,  value: 'ao', name: 'Angola' },
  { id: 6,  value: 'ag', name: 'Antigua and Barbuda' },
  { id: 7,  value: 'ar', name: 'Argentina' },
  { id: 8,  value: 'am', name: 'Armenia' },
  { id: 9,  value: 'au', name: 'Australia' },
  { id: 10, value: 'at', name: 'Austria' },
  { id: 11, value: 'az', name: 'Azerbaijan' },
  { id: 12, value: 'bs', name: 'Bahamas' },
  { id: 13, value: 'bh', name: 'Bahrain' },
  { id: 14, value: 'bd', name: 'Bangladesh' },
  { id: 15, value: 'bb', name: 'Barbados' },
  { id: 16, value: 'by', name: 'Belarus' },
  { id: 17, value: 'be', name: 'Belgium' },
  { id: 18, value: 'bz', name: 'Belize' },
  { id: 19, value: 'bj', name: 'Benin' },
  { id: 20, value: 'bt', name: 'Bhutan' },
  { id: 21, value: 'bo', name: 'Bolivia (Plurinational State of)' },
  { id: 22, value: 'ba', name: 'Bosnia and Herzegovina' },
  { id: 24, value: 'br', name: 'Brazil' },
  { id: 25, value: 'bn', name: 'Brunei Darussalam' },
  { id: 26, value: 'bg', name: 'Bulgaria' },
  { id: 27, value: 'bf', name: 'Burkina Faso' },
  { id: 28, value: 'bi', name: 'Burundi' },
  { id: 29, value: 'kh', name: 'Cambodia' },
  { id: 30, value: 'cm', name: 'Cameroon' },
  { id: 31, value: 'ca', name: 'Canada' },
  { id: 32, value: 'cv', name: 'Cabo Verde' },
  { id: 33, value: 'cf', name: 'Central African Republic' },
  { id: 34, value: 'td', name: 'Chad' },
  { id: 35, value: 'cl', name: 'Chile' },
  { id: 36, value: 'cn', name: 'China' },
  { id: 37, value: 'co', name: 'Colombia' },
  { id: 38, value: 'km', name: 'Comoros' },
  { id: 39, value: 'cg', name: 'Congo' },
  { id: 40, value: 'cr', name: 'Costa Rica' },
  { id: 41, value: 'hr', name: 'Croatia' },
  { id: 42, value: 'cu', name: 'Cuba' },
  { id: 43, value: 'cy', name: 'Cyprus' },
  { id: 44, value: 'cz', name: 'Czech Republic' },
  { id: 45, value: 'cd', name: 'Democratic Republic of the Congo' },
  { id: 46, value: 'dk', name: 'Denmark' },
  { id: 47, value: 'dj', name: 'Djibouti' },
  { id: 48, value: 'dm', name: 'Dominica' },
  { id: 49, value: 'do', name: 'Dominican Republic' },
  { id: 50, value: 'ec', name: 'Ecuador' },
  { id: 51, value: 'eg', name: 'Egypt' },
  { id: 52, value: 'sv', name: 'El Salvador' },
  { id: 53, value: 'gq', name: 'Equatorial Guinea' },
  { id: 54, value: 'er', name: 'Eritrea' },
  { id: 55, value: 'ee', name: 'Estonia' },
  { id: 56, value: 'sz', name: 'Eswatini' },
  { id: 57, value: 'et', name: 'Ethiopia' },
  { id: 58, value: 'fj', name: 'Fiji' },
  { id: 59, value: 'fi', name: 'Finland' },
  { id: 60, value: 'fr', name: 'France' },
  { id: 61, value: 'ga', name: 'Gabon' },
  { id: 62, value: 'gm', name: 'Gambia' },
  { id: 63, value: 'ge', name: 'Georgia' },
  { id: 64, value: 'de', name: 'Germany' },
  { id: 65, value: 'gh', name: 'Ghana' },
  { id: 66, value: 'gr', name: 'Greece' },
  { id: 67, value: 'gd', name: 'Grenada' },
  { id: 68, value: 'gt', name: 'Guatemala' },
  { id: 69, value: 'gn', name: 'Guinea' },
  { id: 70, value: 'gw', name: 'Guinea-Bissau' },
  { id: 71, value: 'gy', name: 'Guyana' },
  { id: 72, value: 'ht', name: 'Haiti' },
  { id: 73, value: 'hn', name: 'Honduras' },
  { id: 74, value: 'hu', name: 'Hungary' },
  { id: 75, value: 'is', name: 'Iceland' },
  { id: 76, value: 'in', name: 'India' },
  { id: 77, value: 'id', name: 'Indonesia' },
  { id: 78, value: 'ir', name: 'Iran (Islamic Republic of)' },
  { id: 79, value: 'iq', name: 'Iraq' },
  { id: 80, value: 'ie', name: 'Ireland' },
  { id: 81, value: 'il', name: 'Israel' },
  { id: 82, value: 'it', name: 'Italy' },
  { id: 83, value: 'jm', name: 'Jamaica' },
  { id: 84, value: 'jp', name: 'Japan' },
  { id: 85, value: 'jo', name: 'Jordan' },
  { id: 86, value: 'kz', name: 'Kazakhstan' },
  { id: 87, value: 'ke', name: 'Kenya' },
  { id: 88, value: 'ki', name: 'Kiribati' },
  { id: 89, value: 'kw', name: 'Kuwait' },
  { id: 90, value: 'kg', name: 'Kyrgyzstan' },
  { id: 91, value: 'la', name: 'Lao People’s Democratic Republic' },
  { id: 92, value: 'lv', name: 'Latvia' },
  { id: 93, value: 'lb', name: 'Lebanon' },
  { id: 94, value: 'ls', name: 'Lesotho' },
  { id: 95, value: 'lr', name: 'Liberia' },
  { id: 96, value: 'ly', name: 'Libya' },
  { id: 97, value: 'li', name: 'Liechtenstein' },
  { id: 98, value: 'lt', name: 'Lithuania' },
  { id: 99, value: 'lu', name: 'Luxembourg' },
  { id: 100, value: 'mg', name: 'Madagascar' },
  { id: 101, value: 'mw', name: 'Malawi' },
  { id: 102, value: 'my', name: 'Malaysia' },
  { id: 103, value: 'mv', name: 'Maldives' },
  { id: 104, value: 'ml', name: 'Mali' },
  { id: 105, value: 'mt', name: 'Malta' },
  { id: 106, value: 'mh', name: 'Marshall Islands' },
  { id: 107, value: 'mr', name: 'Mauritania' },
  { id: 108, value: 'mu', name: 'Mauritius' },
  { id: 109, value: 'mx', name: 'Mexico' },
  { id: 110, value: 'fm', name: 'Micronesia (Federated States of)' },
  { id: 111, value: 'md', name: 'Republic of Moldova' },
  { id: 112, value: 'mc', name: 'Monaco' },
  { id: 113, value: 'mn', name: 'Mongolia' },
  { id: 114, value: 'me', name: 'Montenegro' },
  { id: 115, value: 'ma', name: 'Morocco' },
  { id: 116, value: 'mz', name: 'Mozambique' },
  { id: 117, value: 'mm', name: 'Myanmar' },
  { id: 118, value: 'na', name: 'Namibia' },
  { id: 119, value: 'nr', name: 'Nauru' },
  { id: 120, value: 'np', name: 'Nepal' },
  { id: 121, value: 'nl', name: 'Netherlands' },
  { id: 122, value: 'nz', name: 'New Zealand' },
  { id: 123, value: 'ni', name: 'Nicaragua' },
  { id: 124, value: 'ne', name: 'Niger' },
  { id: 125, value: 'ng', name: 'Nigeria' },
  { id: 126, value: 'mk', name: 'North Macedonia' },
  { id: 127, value: 'no', name: 'Norway' },
  { id: 128, value: 'om', name: 'Oman' },
  { id: 129, value: 'pk', name: 'Pakistan' },
  { id: 130, value: 'pw', name: 'Palau' },
  { id: 131, value: 'pa', name: 'Panama' },
  { id: 132, value: 'pg', name: 'Papua New Guinea' },
  { id: 133, value: 'py', name: 'Paraguay' },
  { id: 134, value: 'pe', name: 'Peru' },
  { id: 135, value: 'ph', name: 'Philippines' },
  { id: 136, value: 'pl', name: 'Poland' },
  { id: 137, value: 'pt', name: 'Portugal' },
  { id: 138, value: 'qa', name: 'Qatar' },
  { id: 139, value: 'ro', name: 'Romania' },
  { id: 140, value: 'ru', name: 'Russian Federation' },
  { id: 141, value: 'rw', name: 'Rwanda' },
  { id: 142, value: 'kn', name: 'Saint Kitts and Nevis' },
  { id: 143, value: 'lc', name: 'Saint Lucia' },
  { id: 144, value: 'vc', name: 'Saint Vincent and the Grenadines' },
  { id: 145, value: 'ws', name: 'Samoa' },
  { id: 146, value: 'sm', name: 'San Marino' },
  { id: 147, value: 'st', name: 'Sao Tome and Principe' },
  { id: 148, value: 'sa', name: 'Saudi Arabia' },
  { id: 149, value: 'sn', name: 'Senegal' },
  { id: 150, value: 'rs', name: 'Serbia' },
  { id: 151, value: 'sc', name: 'Seychelles' },
  { id: 152, value: 'sl', name: 'Sierra Leone' },
  { id: 153, value: 'sg', name: 'Singapore' },
  { id: 154, value: 'sk', name: 'Slovakia' },
  { id: 155, value: 'si', name: 'Slovenia' },
  { id: 156, value: 'sb', name: 'Solomon Islands' },
  { id: 157, value: 'so', name: 'Somalia' },
  { id: 158, value: 'za', name: 'South Africa' },
  { id: 159, value: 'ss', name: 'South Sudan' },
  { id: 160, value: 'es', name: 'Spain' },
  { id: 161, value: 'lk', name: 'Sri Lanka' },
  { id: 162, value: 'sd', name: 'Sudan' },
  { id: 163, value: 'sr', name: 'Suriname' },
  { id: 164, value: 'se', name: 'Sweden' },
  { id: 165, value: 'ch', name: 'Switzerland' },
  { id: 166, value: 'sy', name: 'Syrian Arab Republic' },
  { id: 167, value: 'tj', name: 'Tajikistan' },
  { id: 168, value: 'tz', name: 'Tanzania, United Republic of' },
  { id: 169, value: 'th', name: 'Thailand' },
  { id: 170, value: 'tl', name: 'Timor-Leste' },
  { id: 171, value: 'tg', name: 'Togo' },
  { id: 172, value: 'to', name: 'Tonga' },
  { id: 173, value: 'tt', name: 'Trinidad and Tobago' },
  { id: 174, value: 'tn', name: 'Tunisia' },
  { id: 175, value: 'tr', name: 'Turkey' },
  { id: 176, value: 'tm', name: 'Turkmenistan' },
  { id: 177, value: 'tv', name: 'Tuvalu' },
  { id: 178, value: 'ug', name: 'Uganda' },
  { id: 179, value: 'ua', name: 'Ukraine' },
  { id: 180, value: 'ae', name: 'United Arab Emirates' },
  { id: 181, value: 'gb', name: 'United Kingdom of Great Britain and Northern Ireland' },
  { id: 182, value: 'us', name: 'United States of America' },
  { id: 183, value: 'uy', name: 'Uruguay' },
  { id: 184, value: 'uz', name: 'Uzbekistan' },
  { id: 185, value: 'vu', name: 'Vanuatu' },
  { id: 186, value: 've', name: 'Venezuela (Bolivarian Republic of)' },
  { id: 187, value: 'vn', name: 'Viet Nam' },
  { id: 188, value: 'ye', name: 'Yemen' },
  { id: 189, value: 'zm', name: 'Zambia' },
  { id: 190, value: 'zw', name: 'Zimbabwe' },
];

countries.push({ id: 191, value: 'other', name: 'Other' });


export default function AddLibraryItem() {
  const [title, setTitle] = useState('');
  const [artist, setArtist] = useState('');
  const [files, setFile] = useState('');
  const [artworkFile, setArtworkFile] = useState('');
  const [album, setAlbum] = useState('');
  const [isrc, setISRC] = useState('');
  const [publisher, setPublisher] = useState('');
  const [performer, setPerformer] = useState('');
  const [composer, setComposer] = useState('');
  const [label, setLabel] = useState('');
  const [file_url, setFileUrl] = useState('');
  const [name, setName] = useState('');
  const [country, setCountry] = useState('');
  const [language, setLanguage] = useState('');
  const [genre, setGenre] = useState('');
  const [author, setAuthor] = useState('');
  const [arranger, setArranger] = useState('');
  const [releaseYear, setReleaseYear] = useState('');
  const [youtube, setYouTube] = useState('');
  const [deezer, setDeezer] = useState('');
  const [spotify, setSpotify] = useState('');
  const [file_icon, setFileIcon] = useState(faFile);
  const [isLoading, setIsLoading] = useState(false);
  const [upload_message, setUploadMessage] = useState(
    'Uploading your content...',
  );
  const [upload_progress, setUploadProgress] = useState(0);
  const [upload_enabled, setUploadEnabled] = useState(false);

  let history = useHistory();
  let { user } = useAuthentication();

  let { setNotification } = useContext(NotificationContext);

  function handleArtworkChange(e) {
    setArtworkFile(e.target.files[0].name);
  }

  function handleChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    if (name !== 'file') {
      setName(value);
    } else {
      const value = e.target.files[0];
      setName(value);

      const file_url = URL.createObjectURL(value);
      if (!file_url.endsWith('.wma')) {
        //this.setState({borderColor: '#05ffb0'});
        setUploadEnabled(true);
        setUploadMessage('Uploading your content...');
        setFileIcon(faFileAudio);
        setFileUrl(URL.createObjectURL(value));
      } else {
        message.error(`File type not supported, please try again.`);
      }

      var getTrackName = e.target.value.split('?');
      setFile(getTrackName[getTrackName.length - 1]);
    }
  }

  const handleYouTube = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setYouTube(value);
    }
  };

  const handleSpotify = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(spoti.*fy.*)\/(track\/|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setSpotify(value);
    }
  };

  const handleDeezer = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(deez.*er.*)\/(us\/track\/|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setDeezer(value);
    }
  };

  function handleProgressUpdate(progress) {
    setUploadProgress(progress);
    if (progress === 100) {
      setUploadMessage(
        'Upload is being processed. Please check your email for final results.',
      );
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    let file = $('#input-file')[0].files[0];
    let form = $('#newItemForm').get(0);
    let data = new FormData(form);
    data.append('file', file);
    data.append('user_id', user()?.id);

    // THIS IS A HACK THAT NEEDS A MORE PERMANENT SERVER-SIDE SOLUTION
    const fieldsThatAreRequired = ['album', 'label', 'publisher'];
    fieldsThatAreRequired.forEach((field) => {
      if (!data.get(field)) {
        data.set(field, '-');
      }
    });

    const config = {
      onUploadProgress: function (progressEvent) {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        handleProgressUpdate(percentCompleted);
      }.bind(this),
    };

    ApiConsumer.post(API_ROUTES.LIBRARY.ALL, data, config)
      .then(() => {
        setIsLoading(false);
        history.push('/library');

        setNotification({
          show: true,
          title: 'Upload succeeded',
          message: `music file uploaded successfully`,
          type: 'success',
          time: 3000,
        });
      })
      .catch(() => {
        // console.error(err)
        setIsLoading(false);
        setUploadProgress(0);

        setNotification({
          show: true,
          title: 'Upload failed',
          message: `Upload failed to complete. Please try again later`,
          type: 'error',
        });
      });
  }

  // useEffect(() => {
  //   ApiConsumer.get(API_ROUTES.COUNTRIES.ALL)
  //     .then((res) => {
  //       setCountries(res.data);
  //     })
  //     .catch((err) => console.error(err))
  //     .finally(() => setIsLoading(false));
  // }, []);

  return (
    <div className="relative">
      <form
        id="newItemForm"
        className="min-h-full rounded px-5 py-5 mt-0 bg-white text-gray-800"
        onSubmit={handleSubmit}
      >
        <p className="mt-4 w-full">NB: Fields with *mark are mandatory </p>
        <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faHeadphones}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-title"
              name="title"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Title*"
              required={true}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMicrophoneLines}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-artist"
              name="artist"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Artist*"
              required={true}
              value={artist}
              onChange={(e) => setArtist(e.target.value)}
            />
          </div>

          <div className="sm:col-span-2 sm:row-span-5">
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-4 border-gray-300 border-dashed">
              <div className="space-y-1 text-center">
                <label>
                  <FontAwesomeIcon
                    icon={file_icon}
                    size="5x"
                    aria-hidden="true"
                  />
                  <br />
                  <input
                    name="file"
                    id="input-file"
                    type="file"
                    accept={_validFileExtensions}
                    required={true}
                    value={files}
                    onChange={handleChange}
                    className="invisible"
                  />
                </label>
              </div>
            </div>
            <p style={{ color: 'red' }}>
              Please Note: No Drag-and-Drop functionality. ONLY wav, mp3, mp4 &
              mp4v formats accepted.
            </p>
            <ReactPlayer url={file_url} controls width="100%" height="50px" />

            <div className="relative mt-3 flex rounded-md">
              <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                <FontAwesomeIcon
                  icon={faImage}
                  className="h-4 w-4"
                  aria-hidden="true"
                />
              </span>
              <label className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                {artworkFile === '' ? 'Upload Artwork' : artworkFile}
              </label>
              <div className="absolute inset-y-0 right-0 flex items-center">
                <label className="flex flex-col items-center text-blue tracking-wide cursor-pointer bg-gray-300 text-gray-500 pr-3 h-full py-1 rounded-r-md">
                  <span className="text-base leading-normal">
                    <span>
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="h-4 w-4 px-3"
                        aria-hidden="true"
                      />
                    </span>
                    Browse
                  </span>
                  <input
                    type="file"
                    id="input-artwork"
                    onChange={handleArtworkChange}
                    name="artwork"
                    accept={_validFileExtensionsArtwork}
                    className="hidden"
                  />
                </label>
              </div>
            </div>
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMusic}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <select
              id="genre"
              name="genre"
              onChange={(e) => setGenre(e.target.value)}
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="" disabled selected={true}>
                Genre
              </option>
              {genres.map((genre) => {
                return (
                  <option key={genre.id} value={genre.value}>
                    {genre.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="mt-1 flex rounded-md sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faFileLines}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <select
              id="country_produced"
              name="country_produced"
              onChange={(e) => setCountry(e.target.value)}
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="" disabled selected={true}>
                Country Produced
              </option>
              {countries.map((country) => {
                return (
                  <option key={country.id} value={country.name}>
                    {country.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faCompactDisc}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-album"
              name="album"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Album"
              value={album}
              onChange={(e) => setAlbum(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faFileSignature}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-publisher"
              name="publisher"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Publisher"
              value={publisher}
              onChange={(e) => setPublisher(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMicrophone}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-performer"
              name="performer"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Performing Artist"
              value={performer}
              onChange={(e) => setPerformer(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faPenNib}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-composer"
              name="composer"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Composer"
              value={composer}
              onChange={(e) => setComposer(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faBuilding}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-label"
              name="label"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faPerson}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-author"
              name="author"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-2">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faPeopleCarry}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-arranger"
              name="arranger"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Arranger"
              value={arranger}
              onChange={(e) => setArranger(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md sm:col-span-6 text-left">
            <div className="w-full">
              <div className="w-full mx-auto bg-white rounded-2xl grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex justify-between sm:col-span-2 px-4 py-2 text-sm font-medium text-left text-blue-900 bg-blue-100 rounded-lg hover:bg-blue-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                        <span>Other</span>
                        <ChevronUpIcon
                          className={`${
                            open ? 'transform rotate-180' : ''
                          } w-5 h-5 text-blue-500`}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="py-2 text-sm text-gray-500 sm:col-span-6 grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-4 md:grid-cols-6">
                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faFingerprint}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-isrc"
                            name="isrc"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            placeholder="ISRC"
                            required={false}
                            value={isrc}
                            onChange={(e) => setISRC(e.target.value)}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faCalendar}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-release-year"
                            name="release_year"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Release Year"
                            value={releaseYear}
                            onChange={(e) => setReleaseYear(e.target.value)}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faLanguage}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="language"
                            name="language"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Language"
                            value={language}
                            onChange={(e) => setLanguage(e.target.value)}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faYoutube}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-youtube"
                            name="youtube"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="YouTube page"
                            value={youtube}
                            onChange={handleYouTube}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faDeezer}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-deezer"
                            name="deezer"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Deezer link"
                            value={deezer}
                            onChange={handleDeezer}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-2">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faSpotify}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-spotify"
                            name="spotify"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Spotify link"
                            value={spotify}
                            onChange={handleSpotify}
                          />
                        </div>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            </div>
          </div>

          <div className="mt-1 flex rounded-md sm:col-span-6">
            <Progress
              percent={upload_progress}
              status="success"
              theme={{
                success: {
                  color: '#2ecc71',
                  symbol: upload_progress + '%',
                },
              }}
            />
          </div>

          <div className="mt-1 flex rounded-md sm:col-span-1">
            <button
              type="submit"
              disabled={!upload_enabled}
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500s"
            >
              Submit
            </button>
          </div>
        </div>

        {isLoading ? <Loader upload_message={upload_message} /> : ''}
      </form>
    </div>
  );
}
